<template lang="pug">
transition(name="modal-fade")
    .modal-form-mask
        .modal-form-container(v-bind:class="bindClass")
          .modal-form-header.text-white  {{titulo}}
            button.close.text-white(type='button', @click="$emit('close')")
              span(aria-hidden='true') ×
          .modal-form-body
            slot(name='body')
          .modal-form-footer
            slot(name='footer')
</template>
<script>
export default {
  props : { 
        titulo:String,
        bindClass:String
    } 
}
</script>
<style>
 
    .modal-form-mask {
      position: fixed;
      z-index: 98;
      top: 0;
      left: 0;    
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5); 
      display: table;
    } 
    .modal-form-container {
      margin-top: 15px !important; 
      margin: 0px auto;        
      background-color: #fff;
      padding: 0!important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33); 
      font-family: Helvetica, Arial, sans-serif;     
    } 
    .modal-form-header{
      padding: 15px; 
      border-radius: 0!important;
      background-color: var(--SidebarColorBg);
    }
    .modal-form-body {      
      margin: 5px 0; 
      padding: 10px;
      max-height: 500px;
      overflow: auto;
    }
    .modal-form-footer{ 
      border-top: 1px solid #e9ecef;
      text-align: center; 
      margin: 5px 0; 
      padding: 10px;
    }

    .modal-fade-enter-active {
      transition: all .3s ease;
    }
    .modal-fade-leave-active {
      transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .modal-fade-enter, .modal-fade-leave-to{
      transform: translateX(10px);
      opacity: 0;
    } 

 
</style>
